import { GiHamburgerMenu } from "react-icons/gi";
import { GrClose } from "react-icons/gr";

import React, { useState, useRef, useEffect } from "react";
import styled, { ThemeProvider } from "styled-components";
import { darkTheme, theme } from "../theme";
import { ThemeChangerContainer } from "../pages/PageStyles";
import { IoMoon, IoSunnyOutline } from "react-icons/io5";

const NavbarContainer = styled.div`
  width: 100%;
  height: 5rem;
  position: fixed;
  z-index: 100;
  font-family: ${(props) => props.theme.font};
  transition: 0.2s;
`;
const HamburgerIcon = styled(GiHamburgerMenu)`
  font-size: 1.5rem;
  cursor: pointer;
  position: absolute;
  top: 1.5rem;
  left: 2rem;
  color: ${(props) => props.theme.text};
`;
const CrossIcon = styled(GrClose)`
  font-size: 1.5rem;
  cursor: pointer;
  position: absolute;
  top: 1.5rem;
  left: 2rem;
  color: ${(props) => props.theme.text};
`;
const TableOfContents = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 20rem;
  padding: 0 2rem;
  padding-top: 2rem;
  z-index: 99;
  color: ${(props) => props.theme.text};
  background: ${(props) => props.theme.background};
  box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
  transform: ${({ isopen }) =>
    isopen ? "translateX(0)" : "translateX(-100%)"};
  transition: 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 1px solid ${(props) => props.theme.text};
`;
const TableOfContentsTitle = styled.div`
  font-size: 1.8rem;
  margin: 1.5rem 0;
  font-weight: bold;
  font-family: ${(props) => props.theme.font};
`;

const TableTableOfContentsItemContainer = styled.div``;

const TableOfContentsItem = styled.div`
  font-family: ${(props) => props.theme.font};
  cursor: pointer;
  font-size: 1.2rem;
  margin: 1rem 0;
  position: relative;
  text-align: left;
  width: fit-content;

  &::after {
    content: "";
    position: absolute;
    top: 12px;
    z-index: 100;
    width: 100%;
    transform: scaleX(0);
    height: 2px;
    bottom: 0;
    left: 0;
    background-color: ${(props) => props.theme.text};
    transform-origin: bottom right;
    margin-top: 15px;
    transition: transform 0.25s ease-out;
  }

  &:hover::after {
    transform: scaleX(1);
    transform-origin: bottom left;
  }
`;

const Navbar = (props) => {
  const [isopen, setisopen] = useState(false);
  const [isCross, setIsCross] = useState(false);
  const tableOfContentsRef = useRef(null);

  const toggleTableOfContents = () => {
    setisopen(!isopen);
    setIsCross(!isCross);
  };

  const handleClickOutside = (event) => {
    if (
      tableOfContentsRef.current &&
      !tableOfContentsRef.current.contains(event.target)
    ) {
      setisopen(false);
      setIsCross(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <ThemeProvider theme={props.darkMode ? darkTheme : theme}>
        <NavbarContainer>
          {isCross ? (
            <CrossIcon onClick={toggleTableOfContents} />
          ) : (
            <HamburgerIcon onClick={toggleTableOfContents} />
          )}
        </NavbarContainer>
        <TableOfContents isopen={isopen} ref={tableOfContentsRef}>
          <TableOfContentsTitle>Content</TableOfContentsTitle>
          <TableTableOfContentsItemContainer>
            {props.navbarItems &&
              props.navbarItems.map((item, index) => (
                <TableOfContentsItem
                  key={index}
                  onClick={() => {
                    item.ref.current?.scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  {index + 1 + ". " + item.title}
                </TableOfContentsItem>
              ))}
          </TableTableOfContentsItemContainer>

          <ThemeChangerContainer onClick={() => props.toggleDarkMode()}>
            {props.darkMode ? (
              <IoSunnyOutline style={{ fontSize: "1.7rem" }} />
            ) : (
              <IoMoon style={{ fontSize: "1.7rem" }} />
            )}
          </ThemeChangerContainer>
        </TableOfContents>
      </ThemeProvider>
    </>
  );
};

export default Navbar;
